import React from 'react';
import styled, { css } from 'styled-components';

import PolygonIcon from '@/assets/svg/polygon.svg';
import { media } from '@/utils/mixin';

interface Props {
  title: string;
  items: Array<string>;
}

function SportMode({ title, items }: Props) {
  return (
    <Component>
      <ComponentContainer>
        <Title>{title}</Title>
        <List>
          {items.map((text, index) => (
            <Item key={index}>
              <ItemIcon>
                <PolygonIcon />
              </ItemIcon>
              <ItemText>{text}</ItemText>
            </Item>
          ))}
        </List>
      </ComponentContainer>
    </Component>
  );
}

export default SportMode;

const Component = styled.div`
  background: ${(props) => props.theme.gray_1};
  padding: 40px 0;

  @media (min-width: 1400px) {
    padding: 70px 0;
  }
`;

const ComponentContainer = styled.div`
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  max-width: 67%;

  ${media.tablet(
    css`
      max-width: 100%;
    `
  )}
`;

const Title = styled.h4`
  margin-bottom: 20px;

  font-weight: 700;
  font-size: 20px;
  line-height: 33px;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    margin-bottom: 40px;

    font-size: 26px;
    line-height: 140%;
  }
`;

const List = styled.ul`
  margin-top: 40px;
`;

const Item = styled.li`
  position: relative;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const ItemIcon = styled.span`
  position: absolute;
  top: -3.5px;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-width: 32px;
  height: 32px;

  @media (min-width: 1400px) {
    width: auto;
    height: auto;
    top: 8px;
  }
`;

const ItemText = styled.span`
  padding-left: 42px;
  font-weight: 300;
  font-size: 16px;
  line-height: 140%;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    font-size: 22px;
    padding-left: 52px;
  }
`;
